module.exports = __webpack_public_path__ + "b2d02058a5130da62454624353e85dd2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-1.png
// module id = 3065
// module chunks = 0